import React from 'react'

const Experience = () => {
    return (
        <div className="experience bg-dark-theme py-5 py-md-5 mt-n1">
            <div className="container-fluid">
                <div className="container px-0">
                    <h2 className="text-green font-weight-bold">Work Experience</h2>
                    <div className="row py-3 align-items-md-center">
                        <div className="col-md-4 col-xl-3 my-3">
                            <img className="w-100" src="/assets/aorthar.png" alt="UI Designer" />
                        </div>
                        <div className="col-md-4 col-xl-3 my-3">
                            <img className="w-100" src="/assets/product-designer.png" alt="Product Designer" />
                        </div>
                        <div className="col-md-4 col-xl-3 my-3">
                            <img className="w-100" src="/assets/brave-achievers.png" alt="Brave Designer" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Experience
